import { branches } from '@/configs/translates.config'
export default {
	'add-new-branch': `add new ${branches.en.singular}`,
	'the-branch': `the ${branches.en.singular}?`,
	branch: branches.en.singular,
	'contact-info': 'Contact info'
}